import React from "react";
import { Link as RouterLink } from "react-router-dom";
import MuiLink from "@material-ui/core/Link";

const Link = (props) => {
  return <MuiLink underline="none" component={RouterLink} {...props} />;
};

export default Link;
